import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@chakra-ui/react';
import { useRef } from 'react';
import { useCollapsedText } from './useCollapsedText';
export const CollapsedText = ({ start = false, remain = 10, text, ...textProps }) => {
    const textRef = useRef(null);
    const { collapsedText } = useCollapsedText({ text, start, remain }, textRef);
    return (_jsx(Text, { ...textProps, overflow: "hidden", whiteSpace: "nowrap", ref: textRef, children: collapsedText }));
};
